<script>
    import {
        isPdf,
    } from '$lib/utils'
    import { API_URL } from '$lib/conf';
    import {
        Typography,
        FormBoxContainer,
        SelectX,
        Row,
        StepperWidget as Stepper,
        Column,
        InputFile,
        InputTag,
        InputDate,
        Alert,
        Button,
    } from '$lib/components/UI/'
    import PerceptionsTable from '$lib/custom/components/PerceptionsTable.svelte'
    import Upload from '$lib/components/Icons/custom/Upload.svelte'
    import { blur } from 'svelte/transition'
    import { createEventDispatcher } from 'svelte'
    
    export let value = {
        ivap: 0.21
    }
    export let valid = true
    export let validationOC = v => v.match(/^\d{8}$/)
    export let callbackSend = _ => {}
    let validOC, ocInp
    let isValidAttachment = false
    
    const dispatch = createEventDispatcher()
    function resetData(){
        value = {ivap: 0.21}
        currentStep = 0
    }
    let loading = false
    
    $: valid = Object.entries(value).every(([k, x]) => {
            // @ts-ignore
            return (x && typeof x === 'string' ? x?.length > 0 : x) || k === 'orden_de_compra'
        }) && isValidAttachment;

    let currentStep = 0
</script>

<FormBoxContainer title="Subir Factura" icon={Upload}>
    <Stepper.Group allowBack allowNext bind:currentStep>
        <div style="padding: 0 50px">

            <Stepper.Step label="Factura">
                <div>
                        <InputFile
                                style="text-align: center; height: 50%"
                                bind:value={value.file}
                                bind:valid={isValidAttachment}
                                validation={(d) =>
                                    d instanceof Array &&
                                    d.length > 0 &&
                                    d.every((f) => isPdf(f?.filename) || false)}
                                errMsg="Por favor cargue un documento en formato PDF"
                                endpoint={`${API_URL}/upload`}
                        />
                        <span
                            style="width: 100%;flex-wrap:wrap; display: flex; flex-direction: row; gap: 15px"
                        >
                            <InputTag
                                validation={validationOC}
                                bind:valid={validOC}
                                placeholder="Ingrese su OC (Ej: 12345678 + Enter)"
                                bind:value={value.orden_de_compra}
                                bind:inputValue={ocInp}
                                label="Órdenes de compra (Opcional)"
                            >
                                <span
                                    slot="empty"
                                    style="color: var(--color-grey-300);width: 100%; text-align: center"
                                    >Sin órdenes de compra</span
                                >
                            </InputTag>
                            {#if !validOC && ocInp}
                                <Alert type="error"
                                    >La orden de compra debe estar formada por 8 dígitos
                                    numéricos.</Alert
                                >
                            {/if}
                        </span>
                    <Row justify="flex-end" style="margin-top: 25px; padding-bottom: 25px;">
                        <Button size="small" disabled={!isValidAttachment} on:click={() => {currentStep += 1}}>Siguiente</Button>
                    </Row>
                </div>
            </Stepper.Step>
            <Stepper.Step label="Percepciones">
                <div>
                    <Column>
                            <Row>
                                    <SelectX
                                        required
                                        bind:value={value.ivap}
                                        label="IVA"
                                        validation={v => ![null, undefined].includes(v)}
                                        options={[
                                            {label: '0%', value: 0},
                                            {label: '2.5%', value: 0.025},
                                            {label: '10.5%', value: 0.105},
                                            {label: '21%', value: 0.21},
                                            {label: '27%', value: 0.27}
                                        ]}
                                    />
                            </Row>
                            <Typography type="subtitle">Otras percepciones (Opcional)</Typography>
                            <Column style="border: 1px solid grey; padding: 15px; border-radius: 5px">
                                <PerceptionsTable bind:value={value.percepcion} />
                            </Column>
                            <Column>
                                <InputDate
                                    required
                                    label="Fecha de vencimiento CAE"
                                    bind:value={value.vencimiento_cae}
                                    validation={(x) => x && !['', null, undefined].includes(x)}
                                />
                            </Column>
                            <Row justify="flex-end" style="padding-bottom: 25px">
                                <Button size="small" disabled={loading} on:click={() => currentStep -= 1}>
                                    Atrás
                                </Button>
                                <Button
                                    size="small"
                                    disabled={!valid || loading}
                                    on:click={async () => {
                                        dispatch('send', value)
                                        loading = true
                                        await Promise.resolve(callbackSend(value)).finally(() => {loading = false})
                                        resetData()
                                    }}
                                    label="Subir"
                                />
                            </Row>
                    </Column>
                </div>
            </Stepper.Step>
        </div>
    </Stepper.Group>
</FormBoxContainer>